import React, { useEffect } from "react";
import styled from "styled-components";

const RedirectContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: ${({ theme }) => theme.cardBg};
`;

const LoadingText = styled.p`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.text};
`;

const AppStoreComingSoon = () => {
  useEffect(() => {
    // Перенаправляем пользователя на реальную страницу App Store
    window.location.href =
      "https://apps.apple.com/by/app/1cal-ai-food-calorie-counter/id6745550369";
  }, []);

  return (
    <RedirectContainer>
      <LoadingText>Перенаправление в App Store...</LoadingText>
    </RedirectContainer>
  );
};

export default AppStoreComingSoon;
